import { Container, Grid, Box } from '@mui/material';
import React from 'react';
import OurCover from '../../Component/OurCover/OurCover';
import BlogScss from './Blog.module.scss';
import BlogPost from '../../Component/BlogPost/BlogPost';
import { PostData } from '../../Data/postData';
import SidebarComp from '../../Component/SidebarComp/SidebarComp';

function Blog() {
    return (
        <div>
            <OurCover ourHead="Blog" title="Thoughts and experiments" />
            {/* blogbody */}
            <section id={BlogScss.blogBody}>
                <Container maxWidth='lg' >
                    <Grid container sx={{ width: "auto", mx: "-15px" }}>
                        <Grid item xs={12} md={8} sx={{ px: "15px" }}>
                            <Grid container sx={{ width: "auto", mx: "-15px" }}>
                                {
                                    PostData.map((post) =>
                                        <Grid item xs={12} sm={6} md={6} sx={{ px: "15px" }} key={post.id}>
                                            <BlogPost subject={post.subject} date={post.date} title={post.title} content={post.content} />
                                        </Grid>
                                    )
                                }
                            </Grid>
                            <Box className={BlogScss.BlogButtonBox}>
                                <button type='button' className={BlogScss.BlogButtonLoad}>
                                    load more
                                </button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ px: "15px" }}>
                            <SidebarComp />
                        </Grid>
                    </Grid>

                </Container>
            </section>
        </div>
    )
}

export default Blog;